module.exports = __webpack_public_path__ + "static/media/Picture9.091d5e0b.png";